import React, { useContext, useEffect, useState } from 'react';
import "./style.scss"
import Cards from '../cards/Cards';
import ChartComponent from '../chartComponent/ChartComponent';
import BarComponent from '../barComponent/BarComponent';
import FlowDetails from '../flowDetails/FlowDetails';
import { FilterContext } from '../../../../../../../../providers/filterData-provider';
import { useSelector } from 'react-redux';
import { useFetch } from '../../../../../../../../hooks';

const MainComponent = () => {

    const [trendData, setTrendData] = useState([]);
    const { selectedLendFilterValues } = useContext(FilterContext);
    const lendFilterList = useSelector(state => state?.lendFilter?.data);
    const { api } = useFetch();

    // const filterData = [
    //     selectedLendFilterValues?.from && selectedLendFilterValues?.to && {
    //         id: "APPLICATION_AMOUNT.LAST_MODIFIED_TS",
    //         datatype: "DATE",
    //         value: {
    //             from: selectedLendFilterValues?.from,
    //             to: selectedLendFilterValues?.to
    //         }
    //     },
    //     selectedLendFilterValues?.APPLICATION_HIERARCHY && {
    //         id: "APPLICATION_TASKS_CONFIGS_ACTIVE.ASSIGNED_HIERARCHY",
    //         value: selectedLendFilterValues?.APPLICATION_HIERARCHY
    //     },
    //     selectedLendFilterValues?.APPLICATION_TEAM && {
    //         id: "APPLICATION_TASKS_CONFIGS_ACTIVE.ASSIGNED_TEAM",
    //         value: selectedLendFilterValues?.APPLICATION_TEAM
    //     }
    // ].filter(Boolean);

    // let defaultFilter = null;


    const filterData = Object.keys(selectedLendFilterValues)?.map(key => {
        const filterConfig = lendFilterList?.find(ele => ele?.FILTER_ID === key);

        if (key === 'from' || key === 'to') {
            const dateFilterData = lendFilterList?.find(ele => ele?.DISPLAY_TYPE === 'DATE_PICKER');
            if (dateFilterData) {
                return {
                    id: `${dateFilterData.BASE_TABLE}.${dateFilterData.BASE_COLUMN}`,
                    datatype: 'DATE',
                    value: {
                        from: selectedLendFilterValues.from,
                        to: selectedLendFilterValues.to
                    }
                }
            }
        } else if (filterConfig) {
            const filterValues = Array.isArray(selectedLendFilterValues[key])
                ? selectedLendFilterValues[key] : [selectedLendFilterValues[key]];

            return filterValues?.map(value => ({
                id: `${filterConfig.BASE_TABLE}.${filterConfig.BASE_COLUMN}`,
                value
            }))
        }
        return null;
    }).flat().filter(Boolean);

    const defaultFilter = [
        {
            id: "APPLICATION_TASKS_CONFIGS_ACTIVE.CREATED_TS",
            datatype: "DATE",
            value: 'day'
        }
    ];

    const fetchTrendData = async () => {
        const trendAPI = `${process.env.REACT_APP_BASE_URL}/api/dashboard/lend/charts/applications-trend`;
        const payload = Object.keys(selectedLendFilterValues).length ? { filter: filterData } : { filter: defaultFilter };
        const { data } = await api(trendAPI, 'POST', payload);
        setTrendData(data);
    }

    useEffect(() => {
        fetchTrendData();
    }, [selectedLendFilterValues]);

    const title = selectedLendFilterValues?.from && selectedLendFilterValues?.to ? `from ${filterData[0].value.from} to ${filterData[0].value.to}` : `${defaultFilter[0].value === 'day' ? "today" : defaultFilter[0].value === 'month' ? 'month' : defaultFilter[0].value}`

    return (
        <div className='wrapper'>
            <section className='wrapper__header'>
                <FlowDetails />
            </section>
            <section className='wrapper__content'>
                <div className='wrapper__content__wrapper'>
                    <div className='wrapper__content__wrapper__cards'>
                        <Cards />
                    </div>
                    <div className='wrapper__content__wrapper__pie-chart'>
                        <ChartComponent />
                    </div>
                    <div className='wrapper__content__wrapper__bar-chart'>
                        <BarComponent trendData={trendData} title={title} />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default MainComponent;
